import downredthin from 'assets/icons/down-red.svg';
import upgreenthin from 'assets/icons/up-green.svg';
import React, {Component} from 'react';
import './percent.style.scss';

export default class PercentChart extends Component {
  render() {
    return (
      <div className='percent-container'>
        <h1 className='percent-title'>
          {this.props.title}
          <span className={this.props.up ? 'percent-up' : 'percent-down'}>
            <img
              src={this.props.up ? upgreenthin : downredthin}
              style={{marginRight: 4}}
              alt='icon'
            />
            {this.props.upDownPercent}
          </span>
        </h1>
        <div>
          <span className={this.props.up ? 'percent-price-up' : 'percent-price-down'}>
            {this.props.percent}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/PercentChart/PercentChart.js